<template>
    <div class="text-size-toggle" role="group" :aria-label="label">
        <button
            v-for="option in sizes"
            :key="option.value"
            type="button"
            :class="{ 'is-active': value === option.value }"
            :aria-pressed="value === option.value"
            :aria-label="$t(option.labelKey)"
            :title="$t(option.labelKey)"
            @click.stop="$emit('input', option.value)"
        >
            <span :style="{ fontSize: option.iconSize }">A</span>
        </button>
    </div>
</template>

<script>
import { DEFAULT_MESSAGE_SIZE } from '@/components/Editor/Shared/productOptions';

// Multipliers of the editor's base text size; the preview still shrinks text that would not fit.
const SIZES = [
    { value: DEFAULT_MESSAGE_SIZE, labelKey: 'editor.text_size.small', iconSize: '0.75rem' },
    { value: 1, labelKey: 'editor.text_size.medium', iconSize: '0.95rem' },
    { value: 1.25, labelKey: 'editor.text_size.large', iconSize: '1.2rem' },
];

export default {
    name: 'TextSizeToggle',
    props: {
        value: {
            type: Number,
            default: DEFAULT_MESSAGE_SIZE,
        },
        label: {
            type: String,
            required: true,
        },
    },
    emits: ['input'],
    data() {
        return { sizes: SIZES };
    },
};
</script>
